import React from 'react';

// 分類。標籤形狀加一個穿繩孔。
const IconTag = ({ onClick }) => {
	return (
		<div className='IconTag' onClick={onClick}>
			<svg
				width='20'
				height='20'
				viewBox='0 0 24 24'
				fill='none'
				stroke='#333333'
				strokeWidth='1.6'
				strokeLinecap='round'
				strokeLinejoin='round'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path d='M3.5 3.5h7L21 14a1.6 1.6 0 0 1 0 2.2l-4.8 4.8a1.6 1.6 0 0 1-2.2 0L3.5 10.5v-7Z' />
				<circle cx='7.4' cy='7.4' r='1.4' />
			</svg>
		</div>
	);
};

export default IconTag;
